import React, { useState, useEffect, Fragment } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import axios from "axios";

import { useUserState } from "../../../Contexts/UserContext";
import Basic from "../../../assets/images/basic.png";
import Delux from "../../../assets/images/delux.png";
import Premium from "../../../assets/images/premium.png";
import { de } from "date-fns/locale";

const ChooseFurniturePackage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useUserState();
  const [furPlan, setFurPlan] = useState([]);
  const [loader, setLoader] = useState(false);
  const [companyLoader, setCompanyLoader] = useState(false);
  const [companyId, setCompanyId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [furCompaniesList, setFurCompaniesList] = useState([]);
  const [negotiationPeriod, setNegotiationPeriod] = useState({
    month: 0,
    days: 0,
  });
  const [negoDetail, setNegoDetail] = useState(null);
  const headers = {
    Authorization: user?.token,
  };


  const getCategoriesData = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    setLoader(true);
    try {
      let res = await axios.get(
        `${
          import.meta.env.VITE_APP_BASE_URL
        }/api/furniture-category/get-category-list-by-company/${companyId}`,
        { headers: headersFormData }
      );
      setFurPlan(res?.data?.data);
      setLoader(false);
    } catch (err) {
      console.log("Error while getting furniture plan", err?.message);
      setLoader(false);
    }
  };

  const handlingRouteData = () => {
    if (
      !location?.state?.houseId ||
      !location?.state?.cartId ||
      !location?.state?.startDate ||
      !location?.state?.endDate
    ) {
      navigate("/");
    }
  };
  function calculateDateDifference(startDate, endDate) {
    // Calculate the difference in milliseconds
    const differenceMs = endDate - startDate;

    // Convert milliseconds to days, adding 1 to include both start and end dates
    const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24)) + 1;

    // Calculate months and remaining days
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();

    let diffYear = endDate.getFullYear() - startDate.getFullYear();
    let diffMonth = endDate.getMonth() - startDate.getMonth();
    let months = diffYear * 12 + diffMonth;
    if (months < 0 || (months === 0 && endDay < startDay)) {
      months += 12;
    }

    let remainingDays = endDay - startDay + 1; // Including both start and end dates
    if (
      remainingDays ===
      new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0).getDate()
    ) {
      months++, (remainingDays = 0);
    }

    if (remainingDays < 0) {
      months--;
      const tempDate = new Date(endDate);
      tempDate.setMonth(endDate.getMonth() - 1);
      remainingDays =
        new Date(tempDate.getFullYear(), tempDate.getMonth() + 1, 0).getDate() -
        startDay +
        endDay +
        1; // Including both start and end dates
    }

    return {
      days: differenceDays,
      months: months,
      remainingDays: remainingDays,
    };
  }
  const negotiationDetail = async (negoId) => {
  const headerJson = {
    "Content-Type": "application/json",
    Authorization: user?.token,
  };

  const negoDetails = await axios.get(
    `${import.meta.env.VITE_APP_BASE_URL}/api/house-negotiate-history/get/${negoId}`,
    { headers: headerJson }
  );

  const data = negoDetails.data.data;
  setNegoDetail(data);

  // calculate negotiation period immediately
  const startDate = data?.owner_offered_lease_start_date
    ? new Date(data.owner_offered_lease_start_date)
    : new Date(data.cust_offered_lease_start_date);

  const endDate = data?.owner_offered_lease_end_date
    ? new Date(data.owner_offered_lease_end_date)
    : new Date(data.cust_offered_lease_end_date);

  let { months, remainingDays } = calculateDateDifference(startDate, endDate);
  setNegotiationPeriod({ month: months, days: remainingDays });
};

  useEffect(()=>{
    if(location?.state){
      negotiationDetail(location?.state?.dataId)     
    }
  },[location?.state])
  // calculate negositation period

  useEffect(() => {
    if (companyId) {
      getCategoriesData();
    }
  }, [user?.token, companyId]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);
  const normalizeLeasePeriod = (months, days) => {
    // Convert extra days into months if >= 15 days
    if (days >= 15) {
      months += 1;
    }

    let normalizedLeasePeriod;
    if (months >= 1 && months <= 3) {
      normalizedLeasePeriod = 3;
    } else if (months >= 4 && months <= 6) {
      normalizedLeasePeriod = 6;
    } else if (months >= 7) {
      normalizedLeasePeriod = 12;
    } else {
      normalizedLeasePeriod = 3;
    }

    return normalizedLeasePeriod;
  };

  const handleChooseCompany = async (id, storeId) => {
    debugger;
    const leasperiod = normalizeLeasePeriod(
      negotiationPeriod.month,
      negotiationPeriod.days
    );
    setCompanyId(id);
    setStoreId(storeId);
    setCompanySelectedStatus(true);
    const apiUrl = `${
      import.meta.env.VITE_APP_BASE_URL
    }/api/furniture/get-list?categoryId=${
      location?.state?.furPlanId
    }&companyId=${id}&leasePeriod=${leasperiod}&bedroom=${
      houseDetail?.bedroom_no
    }&bathroom=${houseDetail?.bathroom_no}`;
    setFurListLoader(true);
    try {
      const res = await axios.get(apiUrl, {
        headers: headers,
      });
      setFurList(res?.data?.data);
      furCompaniesList?.filter((item) => {
        if (item?.id === id) {
          setSelectedFurDetail(item);
        }
      });
      let sum = 0;
      res?.data?.data?.forEach((item) => {
        sum += parseInt(item.price); // Parsing the price to ensure it's treated as a number
      });
      setTotalPrice(sum);
      setFurListLoader(false);
    } catch (error) {
      console.error(
        "Error while fetching furniture on behalf of company:",
        error?.message
      );
      setFurListLoader(false);
    }
  };
  const fetchCompaniesList = async () => {
    const apiUrl = `${
      import.meta.env.VITE_APP_BASE_URL
    }/api/user/getAllCompany/furniture_company?houseId=${
      location?.state?.houseId
    }`;
    setCompanyLoader(true);
    try {
      const res = await axios.get(apiUrl, { headers });
      // const filteredCompanies =
      //   res?.data?.data?.filter((item) => item.totalPrice > 0) || [];

      // if (filteredCompanies.length === 0) {
      //   // redirect if no companies
      //   navigate(
      //     `/cleaning-package?cart=${location?.state?.cartId}&&house=${location?.state?.houseId}`,
      //     {
      //       state: {
      //         houseId: location?.state?.houseId,
      //         cartId: location?.state?.cartId,
      //         startDate: location?.state?.startDate,
      //         endDate: location?.state?.endDate,
      //         storeId: storeId,
      //       },
      //     }
      //   );
      //   return; // stop function here
      // }

      setFurCompaniesList(res?.data?.data);
      setCompanyLoader(false);
    } catch (error) {
      console.log(
        "Error while fetching furniture company list",
        error?.message
      );
      setCompanyLoader(false);
    }
  };

  useEffect(() => {
    handlingRouteData();
  }, []);
  useEffect(() => {
    fetchCompaniesList();
  }, [user?.token]);
  const NavigateToCleaning = () => {
    navigate(
      `/cleaning-package?cart=${location?.state?.cartId}&&house=${location?.state?.houseId}`,
      {
        state: {
          houseId: location?.state?.houseId,
          cartId: location?.state?.cartId,
          startDate: location?.state?.startDate,
          endDate: location?.state?.endDate,
          storeId: storeId,
        },
      }
    );
  };
  return (
    <Fragment>
      <div className="banner-section furniture-main">
        <div className="search-home my-container">
          <div className="negotiate-content fur-pkg-comp">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="search-header">
                  <h2>
                    Choose <span>Furniture </span>Company
                  </h2>
                </div>
              </div>
              {companyLoader && (
                <div class="eye-loader-frame m-5 p-5">
                  <div class="eye-loader-spinner"></div>
                </div>
              )}
              {furCompaniesList && furCompaniesList?.length > 0
                ? furCompaniesList?.map((company) => (
                    <div
                      key={company?.companyId}
                      className={`col-12 col-lg-3 col-md-3 ${
                        storeId === company?.companyId ? "active-company" : ""
                      }`}
                    >
                      <div className="trusted-part-title">
                        {/* <p className="furniture_del">
                        Delivery Fee $
                        {company?.furniture_delivery_price +
                          company?.furniture_delivery_extra_price +
                          company?.city_extra_price}
                      </p> */}
                        <h2>{company?.furniture_company}</h2>
                      </div>
                      <div className="trusted-part-radio">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="default"
                            id={company?.companyId}
                            onChange={() => {
                              handleChooseCompany(
                                company?.id,
                                company?.companyId
                              );
                            }}
                          />
                          {/* <span className="furn-off-num">15% OFF</span> */}
                          <label
                            className="form-check-label"
                            htmlFor={company?.companyId}
                          />
                        </div>
                        <div className="furniture-new-price-del">
                          {/* <span>${company?.totalPrice}</span> */}
                        </div>
                      </div>
                    </div>
                  ))
                : !companyLoader && (
                    <div>
                      <h5>No company for this house </h5>
                      <div
                        className="property-content"
                        onClick={() => NavigateToCleaning()}
                      >
                        <div className="property-discription skip">
                          <a>Skip</a>
                        </div>
                      </div>
                    </div>
                  )}
            </div>
          </div>
        </div>
      </div>
      <div className="banner-section customise-furniture-back">
        <div className="all-property-sec customise-furniture-sec">
          <div className="container-fluid my-container">
            <div className="row">
              {furPlan?.length > 0 && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="search-header">
                    <h2>
                      Choose <span>Furniture </span>package
                    </h2>
                  </div>
                </div>
              )}
              {loader && (
                <div class="eye-loader-frame m-5 p-5">
                  <div class="eye-loader-spinner"></div>
                </div>
              )}

              {furPlan?.length > 0
                ? furPlan?.map((ele) => {
                    return (
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-4"
                        key={ele?.id}
                      >
                        <div
                          className="property-inner furniture-content"
                          onClick={() =>
                            navigate(`/furniture`, {
                              state: {
                                houseId: location?.state?.houseId,
                                cartId: location?.state?.cartId,
                                startDate: location?.state?.startDate,
                                endDate: location?.state?.endDate,
                                furPlanId: ele?.id,
                                furPlan: ele?.name,
                                companyId: companyId,
                                storeId: storeId,
                                negotiationPeriod:location?.state?.dataId,
                                
                              },
                            })
                          }
                        >
                          {/* <img
                          src={
                            ele?.name === "Premium Furniture"
                              ? Premium
                              : ele?.name === "Delux Furniture"
                              ? Delux
                              : ele?.name === "Basic Furniture"
                              ? Basic
                              : ""
                          }
                        /> */}
                          <img src={Basic} />
                          <div className="property-content">
                            <div className="property-discription">
                              <h4>{ele?.name}</h4>
                              <a>Choose plans</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : companyId && !loader && (
                    <div>
                      <h5>No package for this house </h5>
                      <div
                        className="property-content"
                        onClick={() => NavigateToCleaning()}
                      >
                        <div className="property-discription skip">
                          <a>Skip</a>
                        </div>
                      </div>
                    </div>
                  )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ChooseFurniturePackage;
